import React from 'react';
import { AcceptDeclineForm } from '../../../../_lib/Form2';
import { SonForm } from '../../../../_lib/Form2';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { MemberType } from '../../../../types/api/MemberType';
import { useModalContext } from '../../../organisms/ModalDialog/ModalContext';
import { useDelayed } from '../../../../hooks/useDelayed';
import { useRefreshBlock } from '../../../../_lib/BlockFetcher';

type MemberDeleteFormProps = {
  form: SonForm<any>;
  member: MemberType;
};

export function MemberDeleteForm({ form, member }: MemberDeleteFormProps) {
  const { t } = useSonTranslation('MemberRow');
  const { refresh } = useRefreshBlock();
  const { closeModal } = useModalContext();
  const delayedCloseAndRefresh = useDelayed(() => {
    refresh();
    closeModal();
  });

  return (
    <AcceptDeclineForm
      messageSuccess={t('status.remove.success')}
      messageSending={t('status.remove.sending')}
      messageFail={t('status.remove.fail')}
      headline={t('status.remove.headline', { name: member.profileName })}
      form={form}
      onSuccess={delayedCloseAndRefresh}
      customErrorTypeMessages={{
        teamroomCoordinatorIsRequired: t('status.changeRoles.teamroomCoordinatorIsRequired'),
      }}
    />
  );
}
